/*
 * Pagination module for sortable lists
 */

define([
  "messaging/messenger",
  "modules/shared/sortableList/sortableListPagination/sortableListPaginationModule",
], function (Messenger, SortableListPaginationController) {
  return SortableListPaginationController.extend({
    initialize: function (options) {
      this.constructor.__super__.initialize.call(this, options);
      this.name = "sortableListPaginationLazyLoading";
      this.totalRecordsModel = options.totalRecordsModel;
      this.model = options.model;
    },
    paginationFilter: function () {
      // The lazy pagination filter works by fetching each page independently, so all the records
      // should always be included
      return () => true;
    },
    setCurrentPage: function (currentPage, { forceUpdate = false } = {}) {
      if (
        forceUpdate ||
        (this.model.get("currentPage") != currentPage &&
          currentPage <= this.model.get("pageCount") &&
          currentPage >= 1)
      ) {
        this.model.set("currentPage", currentPage);

        const eventName = this.namespacePrefix + "pagination:navigate";
        Messenger.vent.trigger(eventName, this.collection, currentPage, this.recordsPerPage);

        this._calculateRecordRange();
        this.view.render();
      }
    },
    _calculateNumberOfPages: async function () {
      await this.totalRecordsModel.onSyncedPromise();
      const totalRecords = this.totalRecordsModel.get("count");
      const pageCount = Math.ceil(totalRecords / this.recordsPerPage); // Calculate page count
      this.model.set({
        pageCount,
        numberOfRecords: totalRecords,
      });
      this._calculateRecordRange();
    },
  });
});
